// extracted by mini-css-extract-plugin
module.exports = {"scroll":"ScrollIndicator_scroll__3KzSG","hidden":"ScrollIndicator_hidden__oEpgU","arrow":"ScrollIndicator_arrow__27_lJ"};